<template>
  <div id="app">
    <router-view />
    <el-dialog
      class="centre"
      width="80%"
      :visible.sync="display.dialog.nonProd.isVisible"
    >
      <h3>友情提示 Notice</h3>
      <p>
        这里是唐宴在线的测试地址，在此地址进行的任何订单和支付操作都将视为测试数据，请慎重使用！
      </p>
      <p>
        This is a testing environment of King Dynasty online. Please do not
        place a formal order or make a real payment.
      </p>
      <el-button
        class="bg-black gold"
        @click="display.dialog.nonProd.isVisible = false"
      >
        确认 OK
      </el-button>
    </el-dialog>

    <el-dialog
      class="centre"
      width="80%"
      title="Notification"
      :visible.sync="display.dialog.sitePopup.isVisible"
    >
      <p>
        {{ display.dialog.sitePopup.message }}
      </p>
      <el-button
        class="bg-black gold"
        @click="display.dialog.sitePopup.isVisible = false"
      >
        Got it
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { env } from "@/utils";
import { listGeneral } from "@/api/setting";

export default {
  name: "app",
  data() {
    return {
      env,
      display: {
        dialog: {
          nonProd: {
            isVisible: env !== "production",
          },
          sitePopup: {
            isVisible: false,
            message: null,
          },
        },
      },

      generalSettings: null,
    };
  },
  async created() {
    this.generalSettings = await listGeneral();
    const sitePopup = this.generalSettings.find(
      (setting) => setting.slug === "site-popup"
    );
    if (sitePopup && sitePopup.details) {
      this.display.dialog.sitePopup.isVisible = true;
      this.display.dialog.sitePopup.message = sitePopup.details;
    }
  },
};
</script>

<style>
body {
  margin: 0 !important;
  -webkit-user-select: none;
  -webkit-touch-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

img {
  pointer-events: none;
}

#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app *:not(i) {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}

.bg-black {
  background-color: #221714 !important;
}

.bg-red {
  background-color: #aa2024 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-gold {
  background-color: #c5b899 !important;
}

.black {
  color: #221714 !important;
}

.red {
  color: #aa2024 !important;
}

.white {
  color: #ffffff !important;
}

.gold {
  color: #c5b899 !important;
}

.gray {
  color: #ddd;
}

.font-bold {
  font-weight: bolder !important;
}

.left {
  text-align: left !important;
}

.centre {
  text-align: center !important;
}

.right {
  text-align: right !important;
}

.border-black {
  border-color: #221714 !important;
}

.border-red {
  border-color: #aa2024 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.border-gold {
  border-color: #c5b899 !important;
}

.border-gray {
  border-color: #ddd;
}

.border-solid {
  border: 1px solid;
}

.no-border {
  border: none !important;
}

.no-border-radius {
  border-radius: 0 !important;
}

.el-loading-spinner .path {
  stroke: #c5b899 !important;
}

.el-button {
  border-radius: 0 !important;
}

.el-message {
  top: 0 !important;
}

.invisible {
  visibility: hidden;
}

.break-word {
  word-break: break-word !important;
}

.justify {
  text-align: justify;
  text-justify: inter-ideograph;
}

.full-width {
  width: 100% !important;
}
</style>
